module.exports = __webpack_public_path__ + "img/B6-bosnia-herzegovina.7ab2bb1b.png";